export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-windows-4.2406dda4.svg";